export const DIVIDER_CLASS_NAME = 'kurama-Divider'
export const DIVIDER_VERTICAL_CLASS_NAME = 'kurama-DividerVertical'
